import { useContext } from 'react';
import { UploadContext } from '.';
export const useUpload = () => {
    const context = useContext(UploadContext);
    if (!context) {
        throw new Error('useUpload hook must be used as a child to <UploadProvider>');
    }
    return context;
};
